var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "table-component",
        {
          ref: "table2",
          attrs: {
            data: _vm.fetchAccountData,
            "show-caption": false,
            "show-filter": false,
            "cache-key": 2,
            "cache-lifetime": "0",
            "filter-no-results": _vm.no_result
          }
        },
        [
          _c("table-column", {
            attrs: {
              show: "companyName",
              sortable: true,
              label: "ACCOUNT NAME"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n          " + _vm._s(row.companyName) + "\n        "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { sortable: false, label: "SCHOOL" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(row) {
                  return [
                    row.schoolFlag
                      ? _c("i", { staticClass: "fa fa-check custom-tick" })
                      : _c("i", { staticClass: "fa fa-times custom-remove" })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              show: "menteeCount",
              sortable: false,
              label: "MENTEE COUNT"
            }
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              show: "assessmentCount",
              sortable: false,
              label: "ASSESSMENT COUNT"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23c86658", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c86658","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/accountlists.vue
// module id = null
// module chunks = 